export type GetIFDefinitionHistoryRequest = {
  dfnSetVerNum: string;
  srcInbdId: string;
  dstOtbdId: string;
  isPrd: boolean;
};
